import React, {type ReactElement} from 'react';

import './WidgetList.css';

export default function WidgetList(props: {
    children: ReactElement | ReactElement[];
    title?: string;
    className?: string;
}): ReactElement {
    return (
        <div className={`widget-list-container${props.className ? ` ${props.className}` : ''}`}>
            {props.title && <div className="widget-list-title">{props.title}</div>}
            <div className="widget-list">{props.children}</div>
        </div>
    );
}
